/**
 * Cenas, Ações e Fluxo de Jogo: o resumo do motor do Mistik Island, e a mesa onde os
 * conflitos entre as duas fontes são decididos.
 *
 * <p><b>Foi esta tela que levou as quatro para o banco.</b> Ela nasceu gravando no GG
 * Pilot porque a coluna "Decisão do Theo" existe para <i>fechar</i> divergência entre o
 * épico-01 e o GDD, e uma decisão que mora no navegador de quem a tomou não foi tomada
 * — ninguém mais a lê. O mesmo argumento valia para as três telas anteriores, e elas
 * vieram junto.
 *
 * <p><b>E foi dela que saiu o {@link PaginaDeQuadros}.</b> O corpo desta tela — estado,
 * gravação por quadro com trava de versão, log de alterações — virou componente quando
 * a página Personagem precisou do mesmo desenho. O que fica aqui é o que só esta página
 * sabe: o conteúdo de fábrica ({@link ./conteudoDeCenasAcoes}), quais quadros têm cor, e
 * o subtítulo. O que o time escreve vence inteiro — ver `combinar`; uma seção nova
 * aparece para quem já tinha gravado a página porque a combinação é por tabela, não por
 * documento.
 */
import { CORES_DAS_LINHAS, ENTREGAS, GRUPOS, SECOES, TABELAS } from './conteudoDeCenasAcoes';
import { PaginaDeQuadros } from './PaginaDeQuadros';
import type { SecaoDeQuadros } from './PaginaDeQuadros';
import { PAGINAS } from './rascunhoDeGameDesign';

/*
 * A coluna de cor aparece onde já há cor: são "As Cenas" e "As Ações", os dois quadros
 * cujo conteúdo de fábrica agrupa por parentesco. Oferecê-la nos treze faria a página
 * perguntar "de que família é esta linha?" em tabelas cujas linhas não têm família
 * nenhuma — um comparador não é lugar, NPC nem evento.
 */
const SECOES_DA_PAGINA: Record<string, SecaoDeQuadros> = Object.fromEntries(
  Object.entries(SECOES).map(([chave, secao]) => [
    chave,
    TABELAS[chave].familias ? { ...secao, cores: CORES_DAS_LINHAS } : secao,
  ])
);

export function CenasAcoesFluxo() {
  return (
    <PaginaDeQuadros
      chave={PAGINAS.cenasAcoesFluxo}
      tabelas={TABELAS}
      secoes={SECOES_DA_PAGINA}
      grupos={GRUPOS}
      entregas={ENTREGAS}
      subtitulo="O motor do jogo: o que é uma cena, o que uma ação faz, e o que ainda está em disputa entre o épico-01 e o GDD."
    />
  );
}
